import type { WebsiteHeaderPhotoSchema_Monogram_v1_1_1 } from '@shared/types/WebsiteHeaderSettings.types';

export const MONOGRAM_v1_1_1: WebsiteHeaderPhotoSchema_Monogram_v1_1_1 = {
  $id: 'https://withjoy.com/assets/public/websiteHeaderSchemas/monogram-v1_1_1.json',
  presentationLayout: 'monogram',
  jsonContainerId: null,
};
